/*
 * @Author: Dong
 * @Date: 2022-04-06 13:56:03
 * @LastEditors: Dong
 * @LastEditTime: 2022-04-06 17:03:57
 */
import React, { Suspense } from 'react';
import { Spin } from 'sup-ui';

// 懒加载
export const lazyLoad = (children: React.ReactNode): React.ReactNode => {
  return <Suspense fallback={<Spin className="outerSpin" />}>{children}</Suspense>;
};
